/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/core";
import { useSwipeable } from "react-swipeable";
import { Fragment } from "react";

import { mq } from "./responsive";

function HomeHeader({ onTop, onScroll, setOnTop, children }) {
  const handlers = useSwipeable({
    onSwipedUp: (e) => setOnTop(false),
    preventDefaultTouchmoveEvent: true,
  });

  return (
    <div {...handlers}>
      <div
        css={{
          backgroundSize: "cover",
          backgroundPosition: "center center",
          padding: `12rem ${onTop ? "4rem" : 0} 0`,
          position: "relative",
          height: onTop ? "100vh" : "fit-content",
          display: "flex",
          flexDirection: "column",
          justifyContent: "flex-end",
          backgroundImage: onTop ? `url("/images/home-header.jpg")` : "",
          transition: "all 0.4s linear",
          zIndex: 2,

          [mq.md]: {
            backgroundImage: `url("/images/home-header.jpg")`,
            height: onTop ? "100vh" : "40rem",
            padding: `14rem ${onTop ? "4rem" : 0} 2rem`,

            "&:before": {
              position: "absolute",
              content: `""`,
              width: "100%",
              height: "100%",
              left: 0,
              top: 0,
              background:
                "linear-gradient(180deg, rgba(0,0,0,0.6) 0%, rgba(255,255,255,0) 40%)",
            },
          },
        }}
      >
        {onTop && (
          <Fragment>
            <div
              css={{
                fontFamily: "Vacations In Paradise",
                fontSize: "10rem",
                color: "#ffffff",
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                width: "100%",
                padding: "0 2rem",
                textAlign: "center",

                [mq.lg]: {
                  fontSize: "16rem",
                },
              }}
            >
              Explore Vietnam with&nbsp;us
            </div>
          </Fragment>
        )}
        {children}
      </div>
    </div>
  );
}

export default HomeHeader;
